import React, { useContext, useEffect} from 'react';
import { useShipper } from '../../../../hooks/useShipper'
import cl from './List.module.css'
import { AppContext } from "../../../../providers/appProvider"
import ErrorModal from '../../../UI/ErrorModal/ErrorModal';
import Pagination from '../../../UI/Pagination/Pagination'; 
import Add from '../Add/Add'; 
import Delete from '../Delete/Delete';
import Edit from '../Edit/Edit';
import tbl from '../../../../assets/Style/Table.module.css'

const ShipperList = () => {

  const { shipperService } = useShipper(50);
  const {appState, app} = useContext(AppContext);

  useEffect( ()=> {
     shipperService.fetchList()
  }, [])


  const handleInputChange = (event) => {
    const { name, value } = event.target;
    shipperService.setFilter({
      ...shipperService.filter,
      [name]: value
    });
  };
 

  return <div>

    <div className={ cl.headMain }> 
        <h1>შიპერი</h1>   
        <Add shipperService={shipperService} /> 
    </div>


    <div className={tbl.table + ' ' + cl.table}>

      <table>
          <thead>
              <tr>
              <th className={cl.id}>#</th>
              <th className={ cl.pad0 }>
                  <input name="name"  placeholder="დასახელება" value={shipperService.filter.name} onChange={handleInputChange} /> 
              </th>
              <th>მობილური</th> 
              <th>მისამართი</th> 
              <th>მისამართი 2</th> 
              <th>კოდი</th> 
              <th>ქვეყანა</th> 
              <th>რეგიონი</th> 
              <th>ქალაქი</th> 
              <th> </th> 
              </tr>
          </thead>
          <tbody>
              {shipperService.items.map((item) =>
                  <tr key={item.id}>
                  <td className={cl.id}>{item.id}</td>
                  <td>{item.name}</td>
                  <td>{item.mobile}</td>
                  <td>{item.address}</td>
                  <td>{item.address2}</td>
                  <td>{item.code}</td>
                  <td>{item.country}</td>
                  <td>{item.district}</td>
                  <td>{item.city}</td>
                  <td className={ cl.btntbl }>
                      <div className={ cl.btns }>
                        <Edit shipperService={shipperService} defaultShipper={item}/>
                        <Delete shipperService={shipperService} defaultShipper={item}/> 
                      </div>
                  </td>
                  </tr>  
              )}
          </tbody>
      </table>

    </div>

  
   {appState.error && <ErrorModal message={appState.error} onClose={() => app.clearError(false)} />}

    <Pagination total={shipperService.total} 
                perPage={shipperService.filter.limit} 
                current={shipperService.filter.page} 
                paginate={(page) => {
                    shipperService.setFilter({
                    ...shipperService.filter,
                    page: page,
                  });
                }}
                setLimit={(limit) => {
                    shipperService.setFilter({
                    ...shipperService.filter,
                    limit: limit,
                  });
                }}
                />
  </div>;
}

export default ShipperList;